import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12.9 2.25H5.1L1.2 9l3.9 6.75h7.8L16.8 9l-3.9-6.75zm-.863 12H5.963L2.933 9l3.03-5.25h6.067L15.06 9l-3.023 5.25z" fill="#54585D" /></svg>);